import React from 'react';
import ReactPlayer from 'react-player';
import numeral from 'numeral';
import _ from 'lodash';
import moment from 'moment';
import { Grid, Segment, Icon, Table, Divider } from 'semantic-ui-react';

const smallText = {
  fontSize: 12,
};

const ProfileLatestYoutubeVideos = ({ youtubeVideos }) => {
  const chunks = _.chunk(youtubeVideos, 3);
  return (
    <Segment padded color="red">
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <h3>
              <Icon name="youtube" color="red" /> Latest Youtube videos
            </h3>
            <Divider />
          </Grid.Column>
        </Grid.Row>
        {
          _.map(chunks, (chunk => <Grid.Row divided columns={3}>
            {_.map(chunk, video => (<Grid.Column key={video.id}>
              <ReactPlayer
                height="202px"
                width="100%"
                url={`https://www.youtube.com/watch?v=${video.id}`}
              />
              <Table singleLine>
                <Table.Row>
                  <Table.Cell>
                    <Icon name="like outline" />
                    { numeral(video.statistics.likeCount).format('0a') }
                  </Table.Cell>
                  <Table.Cell>
                    <Icon name="dislike outline" />
                    { numeral(video.statistics.dislikeCount).format('0a') }
                  </Table.Cell>
                  <Table.Cell>
                    <Icon name="comments outline" />
                    { numeral(video.statistics.commentCount).format('0a') }
                  </Table.Cell>
                  <Table.Cell>
                    <Icon name="youtube play" />
                    { numeral(video.statistics.viewCount).format('0a') }
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell colSpan={4} textAlign="center" style={smallText}>
                    Published on { moment(video.publishedAt).format('MMMM Do YYYY, h:mm:ss a') }
                  </Table.Cell>
                </Table.Row>
              </Table>
            </Grid.Column>))}
          </Grid.Row>),
          )
        }
      </Grid>
    </Segment>
  );
};

ProfileLatestYoutubeVideos.propTypes = {
  youtubeVideos: React.PropTypes.array.isRequired,
};

export default ProfileLatestYoutubeVideos;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-latest/profile-latest-youtube-videos.js
 **/